import React from 'react';

export const Heading: React.FC = props => {
  return (
    <div
      role="heading"
      aria-level={2}
      css={{
        fontVariationSettings: '"wght" 500',
        fontSize: '16px',
        lineHeight: '20px',
        marginBottom: '12px',
      }}
      {...props}
    />
  );
};
